import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

class AdminExportsListHeader extends PureComponent {
  changeOrder(e, field) {
    const {
      order,
      handleChangeOrder,
    } = this.props;

    e.preventDefault();
    handleChangeOrder(field, order === 'asc' ? 'desc' : 'asc');
  }

  render() {
    const {
      intl,
      orderBy,
      order,
    } = this.props;

    return (
      <tr>
        <th className={`th-sortable${orderBy === 'created_at' ? ' active' : ''}`}>
          <a href="#sort" onClick={(e) => { this.changeOrder(e, 'created_at'); }}>
            {intl.formatMessage({ defaultMessage: 'Created' })}
            {' '}
            {orderBy === 'created_at' && (
              <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
            )}
          </a>
        </th>
        <th>
          {intl.formatMessage({ defaultMessage: 'Period' })}
        </th>
        <th>
          {intl.formatMessage({ defaultMessage: 'Results' })}
        </th>
        <th>
          {intl.formatMessage({ defaultMessage: 'Status' })}
        </th>
        <th>
          {' '}
        </th>
      </tr>
    );
  }
}

AdminExportsListHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
};

export default injectIntl(AdminExportsListHeader);
